import './index.css'

const BannerCard = props => {
  const {bannerCardItem} = props
  const {headerText, description, className} = bannerCardItem
  return (
    <li className={className}>
      <div className="container">
        <h1 className="heading">{headerText}</h1>
        <p className="paragraph">{description}</p>
        <button type="button" className="showButton">
          Show More
        </button>
      </div>
    </li>
  )
}

export default BannerCard
